import { render, staticRenderFns } from "./view_rating.vue?vue&type=template&id=a4eed05e&scoped=true"
import script from "./view_rating.vue?vue&type=script&lang=js"
export * from "./view_rating.vue?vue&type=script&lang=js"
import style0 from "./view_rating.vue?vue&type=style&index=0&id=a4eed05e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4eed05e",
  null
  
)

export default component.exports